import React from 'react';
import PropTypes from 'prop-types';

var CheckBox = (props) => {
  const inlineStyle = props.inline ? {'display':'inline'}:{}
  return (
    <div style={inlineStyle}>
      <label>
        <div className="checkbox-styled">
          <input
            className={`${props.class}`}
            type="checkbox"
            checked={props.value}
            disabled={props.isDisabled}
            onChange={(e) => {
              props.onChange(props.property, e.target.checked, e)
            }
          }
          onBlur={props.onBlur}
          onFocus={props.onFocus}
          />
          <ins/>
        </div>
        <label>{props.label}</label>
      </label>
    </div>
  )
}


CheckBox.propTypes = {
  property: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  inline: PropTypes.bool,
  label: PropTypes.string,
  value: PropTypes.bool,
  class: PropTypes.string,
  isRequired: PropTypes.bool,
}

CheckBox.defaultProps = {
  inline: false,
  label: "",
  value: false,
  class: "",
  isValid: true,
  isRequired: false,
}

export default CheckBox
